import React from "react";
import {
	Datagrid,
	EditButton,
	List,
	ReferenceField,
	TextField,
	usePermissions,
} from 'react-admin';

import {DatagridWithBlockDeleteProps} from '../../../components/_helpers/props/DatagridProps';
import {stylesForColorInheritInList} from "../../../components/_helpers/useStyles";
import { PhoneField } from '../../../components/fields/PhoneField';
import {StyledEmailField} from "../../../components/fields/StyledEmailField";
import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import {HideBlockUnblockButtonIfDeleted} from '../../../components/toolbars/BlockUnblockButton';
import DeleteRestoreButtons from "../../../components/toolbars/DeleteRestoreButtons";
import { AppManagerRoles, UserRole } from '../../../entities/UserRole';
import { isInArray } from "../../../utils/general";
import { DriversFilter } from './ListFilters';

const defaultSort = { field: 'id', order: 'DESC' };


export const DriversList = (props) => {
	const classes = stylesForColorInheritInList()
	const { permissions } = usePermissions();

	if (!permissions) {
		return null;
	}

	const isAdmin = isInArray(AppManagerRoles, permissions.role)
	
	// INFO: not used
	// const companyReference = isAdmin ? "companies" : "transporters";

	return (
		<List
			{...props}
			exporter={false}
			bulkActionButtons={false}
			filters={isAdmin ? <DriversFilter /> : undefined}
			sort={defaultSort}
			classes={classes}
		>
			<ScrollingWrapper>
				<Datagrid
					{...DatagridWithBlockDeleteProps}
					// expand={<DriverExpandPanel />}
					rowClick="show"
				>
					<TextField source="id" />
					{isAdmin && <ReferenceField source="company_id" reference={"companies"} link={false}>
						<TextField source="full_name" />
					</ReferenceField>}
					<TextField source="first_name" />
					<TextField source="last_name" />
					<ReferenceField source="truck_id" reference={"trucks"} link={false} >
						<TextField source="name" />
					</ReferenceField>
					<TextField source="trailer_number" />
					<StyledEmailField source="email" />
					<PhoneField source="phone" />
					{props.hasEdit && <EditButton label="" />}
					{(
						// permissions.role === UserRole.customer_manager ||
						permissions.role === UserRole.customer_and_transporter_manager ||
						permissions.role === UserRole.transporter_manager ||
						permissions.role === UserRole.admin
					) && <HideBlockUnblockButtonIfDeleted entity={"user"}/>}					
					{(
						// permissions.role === UserRole.customer_manager ||
						permissions.role === UserRole.customer_and_transporter_manager ||
						permissions.role === UserRole.transporter_manager ||
						permissions.role === UserRole.admin
					) && (
						<DeleteRestoreButtons
							replaceResource="user-is-deleted"
							confirmDeleteStringKey="osfc.dialogs.confirm_delete_user"
							confirmRestoreStringKey="osfc.dialogs.confirm_restore_user"
						/>)}
				</Datagrid>
			</ScrollingWrapper>
		</List>
	);
}
